import { render, staticRenderFns } from "./audio_container.vue?vue&type=template&id=522185e9&scoped=true&"
import script from "./audio_container.vue?vue&type=script&lang=js&"
export * from "./audio_container.vue?vue&type=script&lang=js&"
import style0 from "./audio_container.vue?vue&type=style&index=0&id=522185e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522185e9",
  null
  
)

export default component.exports